import React from 'react'
import '../../../App.css';
import {Link} from 'react-router-dom';

export default function Labyrinth() {
    return(
        <>
            <Link to="/DigitalPortfolio/projects" className="nav-back">
                <div className='nav-back-text'>{"<"}Back</div>
            </Link>
            <h1 className='header'>The Labyrinth</h1>
        </>
    )
}